<template>
    <div>
        <div class="logos">
            <div class="box">
                <p>Logo tradicional (Colorida)</p>
                <div class="preview" v-if="logo.preview">
                    <img :src="logo.preview" alt="" class="image-preview">
                    <button class="close_branca" @click="clear('logo')">X</button>
                </div>
                <a role="button" class="upload" @click="$refs.input_logo.click()" v-else>
                    <i class="material-icons">image</i>
                </a>
                <input class="file" ref="input_logo" type="file" name="logo" accept="image/*"
                       @change="previewFile($event, 'logo')" />
            </div>

            <div class="box">
                <p> Logo aplicada para fundo escuro (Branca)</p>
                <div class="preview" v-if="logo_branca.preview">
                    <img :src="logo_branca.preview" alt="" class="image-preview">
                    <button class="close_branca" @click="clear('logo_branca')">X</button>
                </div>
                <a role="button" class="upload" @click="$refs.input_logo_branca.click()" v-else>
                    <i class="material-icons">image</i>
                </a>
                <input class="file" ref="input_logo_branca" type="file" name="logo_branca" accept="image/*"
                       @change="previewFile($event, 'logo_branca')" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                logo: {
                    preview: null,
                    blob: null
                },
                logo_branca: {
                    preview: null,
                    blob: null
                },
            };
        },

        props: {
            logo_url: String,
            logo_branca_url: String,
        },

        methods: {
            previewFile($event, name) {

                const blob = $event.target.files[0];


                this[name] = {
                    blob,
                    preview: window.URL.createObjectURL(blob)
                }

                this.updateBlob(name)
            },

            clear(name) {
                this[name] = {
                    preview: null,
                    blob: null
                }
                this.updateBlob(name)
            },

            updateBlob(name) {
                this.$emit('input', {
                    logo: this.logo.blob,
                    logo_branca: this.logo_branca.blob
                });
                this.$emit(`update:${name}_url`, this[name].preview);
            }
        },

        watch: {

            logo_url: {
                immediate: true,
                handler(url) {
                    this.logo.preview = url;
                }
            },

            logo_branca_url: {
                immediate: true,
                handler(url) {
                    this.logo_branca.preview = url;
                }
            }
        }

    };
</script>

<style lang="scss" scoped>
    .file {
        display: none;
    }

    .p15 {
        padding: 15px;
        display: flex;
    }

    .box {
        height: 350px;
        margin: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .logos {
        /* display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px; */
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        /* margin: 0 auto; */
        width: 100%;

    }

    .upload {
        width: 300px;
        max-width: 100%;
        height: 300px;
        background: transparent;
        border: 1px solid var(--color-primary);
        border-radius: 15px;
        padding: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .upload i {
        font-size: 200px;
        color: #eee;
    }

    .image-preview {
        width: 300px;
        height: 300px;
        border: 1px solid var(--color-primary);
        object-fit: contain;
        border-radius: 15px;
        max-width: 100%;
        padding: 10px;
        background-color: #e1e1e1;
        background-image: linear-gradient(45deg, #aaa 25%, transparent 25%), linear-gradient(-45deg, #aaa 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #aaa 75%), linear-gradient(-45deg, transparent 75%, #aaa 75%);
        background-size: 20px 20px;
        background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }

    .close_branca {
        position: relative;
        background: red;
        width: 25px;
        height: 25px;
        border: none;
        border-radius: 50%;
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
        color: #fff;
        font-weight: bold;
        margin-top: -310px;
        margin-left: auto;
        right: -8px;
    }

    .preview{
        height: 300px;
    }


    @media (max-width: 767px) {
        .logos {
            justify-content: center;
        }

        .box {
            width: 100%;
        }

        .upload {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/upload/TwoImage.vue